import React, {Component} from 'react';

import { dt, t } from 'l10n';
import Loading from 'components/Loading';
import ModalChangeEmail from 'components/modals/ModalChangeEmail';
import ItemSettingCheckBlock from './ItemSettingCheckBlock';

class ItemCheckBlockList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: props.email,
            pendingSend: false,
            modalChangeEmail: false,
            settings: props.settings,
            messages: {
                followees: 'When others start following me:',
                followed: 'When a followed user is connected:',
                message: 'When I receive a new message in my Inbox:',
                guestbook: 'When I receive a message in my guestbook:',
                tip: "When I receive tokens:",
                gift: "When I receive virtual gift:",
                real_gift: "When I receive Bobstore gift:",
                membership_gift: "When I receive an XXL membership gift:",
                wall_notify: 'When new photo or video is posted on The Wall:'
            }
        };
    }

    viewModalChangeEmail() {
        const { modalChangeEmail } = this.state;
        this.setState({modalChangeEmail: !modalChangeEmail});
    }

    changeEmail(newEmail) {
        this.setState({email: newEmail});
    }

    changeSettings(name, value) {
        this.setState(prevState => ({
            settings: {
                ...prevState.settings,
                [name]: value
            },
        }));
    }

    sendSettings() {
        const { saveSettings } = this.props;
        const { settings } = this.state;

        this.setState({pendingSend: true});

        const reducerParams = {
            settings: JSON.stringify(settings)
        };
        saveSettings(reducerParams).promise
            .then(() => this.setState({pendingSend: false}))
            .catch(() => this.setState({pendingSend: false}))
    }

    createList() {
        const {
            messages,
            settings,
        } = this.state;

        return Object.keys(settings).map((name, key) =>
            <ItemSettingCheckBlock
                key={key}
                id={key}
                name={name}
                settings={settings[name]}
                title={messages[name]}
                changeSettings={(name, value) => this.changeSettings(name, value)}
            />
        );
    }

    render() {
        const { 
            email,
            newEmail,
            pendingSend,
            modalChangeEmail
        } = this.state;

        const { message } = this.props;

        return (
            <div>
                <div className="change-email">
                    <div className="input-blocked">
                        <div className="input-blocked-container">
                            <div className="text">{dt('notifications', 'You will receive notifications at')}</div>
                            <div className="email">{email}</div>
                        </div>
                    </div>
                    <button className="ui-button primary" onClick={() => this.viewModalChangeEmail()}>{dt('notifications','Change email address')}</button>
                </div>
                <div className="check-list">
                    {pendingSend ? <Loading centered/> : null}
                    {this.createList()}
                   <div className="message-container">
                       <span className="message">{message}</span>
                       <button className="ui-button primary save" onClick={() => this.sendSettings()}>{t('Save')}</button>
                   </div>
                </div>
                <ModalChangeEmail setStateNewEmail={(newEmail) => this.changeEmail(newEmail)} show={modalChangeEmail} closeFn={() => this.viewModalChangeEmail()}/>
            </div>
        )
    }
}

export default ItemCheckBlockList;



// WEBPACK FOOTER //
// ./src/components/notification/ItemSettingCheckBlockList.js